<template>
  <div class="site-header-wrap">
    <header class="site-header">
      <RouterLink to="/" class="brand">
        <MelonMark :size="34" />
        <span class="brand-word">Frases <em>Melón</em></span>
      </RouterLink>

      <SearchBar />

      <UserMenu
        :is-logged-in="isLoggedIn"
        :username="username"
        @login="$emit('login')"
        @register="$emit('register')"
        @profile="$emit('profile')"
        @logout="$emit('logout')"
        @my-quotes="$emit('my-quotes')"
      />
    </header>

    <!-- Divisor festoneado: repite la misma curva de corteza que MelonMark -->
    <div class="rind-divider"></div>
    <div class="rind-divider-shadow"></div>
  </div>
</template>

<script setup>
import MelonMark from "./MelonMark.vue";
import SearchBar from "./SearchBar.vue";
import UserMenu from "./UserMenu.vue";

defineProps({
  isLoggedIn: { type: Boolean, default: false },
  username: { type: String, default: "" },
});

defineEmits(["login", "register", "profile", "logout", "my-quotes"]);
</script>

<style scoped>
.site-header-wrap {
  position: sticky;
  top: 0;
  z-index: 20;
}

.site-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 28px;
  background: var(--paper);
}

.brand {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  user-select: none;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.brand-word {
  font-family: "Fraunces", serif;
  font-weight: 600;
  font-size: 26px;
  letter-spacing: -0.01em;
  color: var(--ink);
  line-height: 1;
  white-space: nowrap;
}
.brand-word em {
  font-style: italic;
  font-weight: 500;
  color: var(--melon-deep);
}

.rind-divider {
  height: 12px;
  width: 100%;
  background: radial-gradient(
        circle at 9px 0,
        transparent 9px,
        color-mix(in srgb, var(--rind) 90%, transparent) 9.5px
      )
      top / 18px 12px repeat-x,
    var(--paper);
}

.rind-divider-shadow {
  height: 4px;
  width: 100%;
  background: linear-gradient(to bottom, rgba(43, 32, 24, 0.06), transparent);
}

@media (max-width: 700px) {
  .site-header {
    padding: 12px 16px;
  }
  .brand-word {
    font-size: 21px;
  }
}

@media (max-width: 520px) {
  .brand-word {
    display: none;
  }
}
</style>